<div class="main-page">
  <nav class="navbar navbar-expand-lg navbar-light bg-light header">
    <!-- <a class="navbar-brand" routerLink="/select-criteria"> <span class="nav-divnk time" ><i class="fa fa-long-arrow-left" style="font-size:48px;color:#fff;margin-top:-16px;"></i></span></a> -->
    <!-- <div class="form-inline my-2 my-lg-0">
          <span class="nav-divnk">Make Payment</span>
      </div> -->

    <div class="logo">
      <a (click)="redirect()"><img src="assets/logo-4.png" /></a>
    </div>
  </nav>

  <div class="container">
    <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
    <div class="base-payment-page">
      <div class="base-payment-page-inner">
        <div class="container1">
          <div></div>
          <div></div>
          <div class="active"></div>
          <div></div>
        </div>
        <h4>{{bannerPlanId ? 'Banner Plan': 'Subscription Plan'}} Checkout</h4>
        <span *ngIf="isDiscount == 'true'" style="margin-top:-10px;">
          <small><b>Your plan entitles you to a 50% discount on a Business Banner and ads. </b></small>
          <!-- Create one today and save! -->
      </span>

        <div *ngIf="!bannerPlanId" class="row plan-name">
          <p>{{ plan.caption }}</p>
          <div class="price-cust col-md-1">
            <p>${{ plan.price }}</p>
          </div>
          <!-- <div class="des-h col-md-8 float-right">
            <p>
              ({{ plan.days == 1 ? plan.days + " day" : plan.days + " days" }})
              {{ plan.caption }}
            </p>
          </div> -->
        </div>
        <!-- <div>
        <button *ngIf="!bannerPlanId" class="discountSubs">Discount: $500</button>
      </div> -->
      <div class="discount" *ngIf="!bannerPlanId && plan?.price != 0 && hasEarlyBirdOffer()">
        <ng-container *ngIf="plan.price === 995; else discount35 ">
          Discount: $500
        </ng-container>
      </div>

      <!-- Template for 35% discount -->
      <ng-template #discount35>
        <div class="discount1">
          Discount: 35%
        </div>
      </ng-template>


        <div *ngIf="bannerPlanId">
          <div class="row plan-name">
            <div class="price-cust col-md-4">
              <p>${{ price}} / {{convertSubscripitonType( bannerPlanData.days)}}
              </p>
            </div>
            <div class="des-h col-md-8 float-right">
              <p>
                <!-- ({{ bannerPlanData?.days + " days" }}) -->
                <!-- {{ bannerPlanData?.caption }} -->
              </p>
            </div>
          </div>
        </div>
        <div class="discount" style="width: 145px;
        padding: 5px;
        position: relative;
        background: green;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        color: white;" *ngIf="discount && bannerPlanId && plan?.price != 0">Discount: ${{ discount }}</div>
        <div style="text-align: center;" *ngIf="bannerPlanId">
          <h6> You have chosen the following Business Banner plan: </h6>
          <h6 *ngIf="category"> Category: <b>{{category}}</b></h6>
          <h6 *ngIf="bannerPlanData?.caption"> Visibilty: <b>{{bannerPlanData.caption}}</b></h6>
          <p *ngIf="bannerPlanData?.bannerSize"> Size: <b>{{bannerPlanData.bannerSize}}</b></p>
        </div>
        <div *ngIf="invalidError" style="color: red">
          {{ invalidError.message }}
        </div>
        <form
          #checkout="ngForm"
          (ngSubmit)="onSubmit(checkout)"
          class="checkout"
        >
          <div class="form-row">
            <!-- <label for="card-info">Card Info</label> -->

            <div *ngIf="!isDefault" class="card">
              <div class="row">
                <div class="col-md-9">
                  <div #cardInfo></div>
                </div>
                <div class="col-md-3">
                  <button
                    type="submit"
                    class="btn btn-primary mb-2 add-card-buttom"
                  >
                    Confirm Card
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="isDefault" class="card">
              <div class="row">
                <div class="col-md-9">
                  Selected Default Card for Payment: XXXX-XXXX-XXXX-{{cardForPayment.last4}}
                  OR
                  <span
                  (click)="openCardModal()"
                    class="btn btn-primary add-card-buttom"
                  >
                    Add Card
                  </span>
                </div>
              </div>
            </div>

            <div class="coupen">
              <h6 style="margin: 0px; margin-left: 5px;">Discount Code</h6>
              <form
                class=""
                [formGroup]="form"
                (ngSubmit)="applyCoupon(form.value)"
              >
                <div class="row">
                  <div class="col-sm-12 col-md-9">
                    <div class="any-coupen">
                      <label for="inputPassword2" class="sr-only"
                        >Apply Coupon Code</label
                      >
                      <input
                        formControlName="couponId"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-3">
                    <button type="submit" class="btn btn-primary mb-2" disabled>
                      Apply
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <br />
            <div class="card-text-input-main">
              <div class="card-list card-text-input">
                <br />
                <div
                  *ngFor="let item of cards"
                  class="card-text-input"
                  style="text-align: end"
                >
                  <div class="row">
                    <div class="col-md-5 cards-anchor">
                      <a>XXXX-XXXX-XXXX-{{ item.last4 }}</a>
                    </div>

                    <div class="col-md-4">
                      <span
                      *ngIf="item.id == defaultCard"
                      (click)="setDefault(item)"
                        class="make-default-button btn btn-primary mb-2"
                      >
                        Default Card
                      </span>
                      <span
                      *ngIf="item.id !== defaultCard"
                      (click)="setDefault(item)"
                      class="make-default-button btn btn-primary mb-2"
                      style="display: flex;
                        align-items: center;
                        justify-content: center;"
                      >
                      Select Saved Card
                      </span>
                    </div>

                    <div class="col-md-3 default-trash-icon">
                      <a (click)="removeCard(item.id)"
                        ><i
                          class="del fa fa-trash"
                          aria-hidden="true"
                          style="color: rgb(182, 25, 25)"
                        ></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-style recurring-text">
            <p style="text-align: center !important">
              <span class="recurring-class" *ngIf="!(plan.price == 995)">Recurring billing. Cancel anytime.</span>
              <br />
              <span *ngIf="bannerPlanId">By hitting pay, you will be charged the amount shown monthly.  Business Banner plans renew automatically unless cancelled at least 24-hours prior to the end of the current billing period.</span><span *ngIf="!bannerPlanId">By hitting Pay, you will be charged a one time payment.<span *ngIf="!(plan.price == 995)"> Subscriptions automatically
              renew unless canceled in “My Subscription” at least 24-hours prior
             <!-- for them duration of the selected subscription. -->
              to the end of the current subscription period.</span></span><br />
            </p>
            <p class="term">
              <a
                href="https://ravel.faith/policies/ravel-terms/"
                target="_blank"
                ><b>Terms of Services</b> </a
              ><span> and </span
              ><a
                href="https://ravel.faith/policies/privacy-policy/"
                target="_blank"
                ><b>Privacy Policy</b></a
              >
            </p>
          </div>
        </form>

<div class="cancle-btn">
        <button
          type="submit"
          class="btn mb-2 button-c"
          (click)="cancelSubs()"
        >
          Cancel
        </button>

        <div class="pay-button">
          <button *ngIf=" !bannerPlanId"
            type="submit"
            class="btn btn-primary mb-2 button-c"
            [class.blur]="cards.length === 0"
        [disabled]="cards.length === 0"
            (click)="basicSubscription(cardId)"
          >
            Pay ${{ getPayableAmount() }}
          </button>
          <button  *ngIf="bannerPlanId"
          type="submit"
          class="btn btn-primary mb-2 button-c"
          (click)="bannerPlanSubscription(cardId)"
        >
          Pay ${{price - discount}}
        </button>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>
